export default "__VITE_ASSET__fe827708__"